(function () {
    const mobileNavigationWrapper = document.querySelector('.hamburger-navigation-wrapper');
    const mobileNavigationHandle = document.querySelector('.js-navigation-toggle');
    const mobileNavigationButtonName = document.querySelector('.js-navigation-toggle .js-content');
    const pageHeader = document.querySelector('.js-page-header');

    const toggleMenu = () => {
        // Toggle alle nødvendige klasser
        mobileNavigationWrapper.classList.toggle('open');
        pageHeader.classList.toggle('page-header-mobile');
        mobileNavigationHandle.classList.toggle('open');
        document.body.classList.toggle('menu-open'); // Legger til/fjerner menu-open på body

        // Toggle button text
        const isOpen = mobileNavigationHandle.classList.contains('open');
        
        mobileNavigationButtonName.textContent = isOpen 
            ? mobileNavigationHandle.getAttribute('data-close-label').toUpperCase() 
            : mobileNavigationHandle.getAttribute('data-expand-label').toUpperCase();
    };

    mobileNavigationHandle.addEventListener('click', function (e) {
        e.preventDefault();
        toggleMenu();
    });
})();